"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetTable = void 0;
var morse_react_1 = require("morse-react");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
/**
 * A table component to display tabular data from a data set for a configured list of columns.
 *
 * @param props
 * @returns
 */
var DatasetTable = function (props) {
    var _a;
    var dataset = props.dataset, sorts = props.sorts, onSortDirectionChange = props.onSortDirectionChange, columns = props.columns, rowRender = props.rowRender, onRowClick = props.onRowClick, rowLinkTo = props.rowLinkTo, footer = props.footer, additionalHeaders = props.additionalHeaders, tableProps = __rest(props, ["dataset", "sorts", "onSortDirectionChange", "columns", "rowRender", "onRowClick", "rowLinkTo", "footer", "additionalHeaders"]);
    // Give plugins the opportunity to inject columns
    var columnsWithInjections = __spreadArray([], columns);
    (_a = props.plugins) === null || _a === void 0 ? void 0 : _a.forEach(function (plugin) {
        if (!plugin.injectedColumns) {
            return;
        }
        plugin.injectedColumns(props.pluginOptions).forEach(function (_a) {
            var definition = _a.definition, position = _a.position;
            if (!position || position === "end") {
                columnsWithInjections.push(definition);
            }
            else if (position === "start") {
                columnsWithInjections.unshift(definition);
            }
            else {
                columnsWithInjections.splice(position, 0, definition);
            }
        });
    });
    // Build the collection of headings
    var headings = columnsWithInjections.map(function (inputColumn, index) {
        var _a, _b, _c, _d;
        var column = typeof inputColumn !== "object" ? { propertyName: inputColumn } : inputColumn;
        if (column.hide) {
            return null;
        }
        var sort = sorts === null || sorts === void 0 ? void 0 : sorts.find(function (sortObject) { var _a; return sortObject.property === ((_a = column.sortablePropertyName) !== null && _a !== void 0 ? _a : column.propertyName); });
        var isSortable = !!sort ||
            ((_a = column.headingCellProps) === null || _a === void 0 ? void 0 : _a.sortable) ||
            column.sortable ||
            column.sortablePropertyName ||
            (column.sortablePropertyName &&
                ((_b = props.sortableProperties) === null || _b === void 0 ? void 0 : _b.includes(column.sortablePropertyName))) ||
            (column.propertyName && ((_c = props.sortableProperties) === null || _c === void 0 ? void 0 : _c.includes(column.propertyName)));
        var sortDirection = sort === null || sort === void 0 ? void 0 : sort.direction;
        var handleOnClick = isSortable
            ? function () {
                var _a;
                if (props.onSortDirectionChange &&
                    (column.sortablePropertyName || column.propertyName)) {
                    props.onSortDirectionChange(
                    // TODO: Improve typing so that we can remove the following assertion.
                    ((_a = column.sortablePropertyName) !== null && _a !== void 0 ? _a : column.propertyName), sortDirection === morse_react_1.SortDirection.Descending || sortDirection === undefined
                        ? morse_react_1.SortDirection.Ascending
                        : morse_react_1.SortDirection.Descending);
                }
            }
            : undefined;
        var toRender = undefined;
        // Give plugins the opportunity to render
        (_d = props.plugins) === null || _d === void 0 ? void 0 : _d.forEach(function (plugin) {
            if (plugin.headingRender) {
                var pluginWantsToRender = plugin.headingRender(column, props.dataset, props.pluginOptions);
                // Other falsy values may be valid ReactNodes, such as null, hence the explicit check
                if (pluginWantsToRender !== false) {
                    toRender = pluginWantsToRender;
                }
            }
        });
        if (toRender === undefined) {
            /**
             * No plugins rendered
             * 1. If heading cell rendering is overridden generally, use that as first preference
             * 2. Use heading text
             * 3. Use wordified property name
             * 4. Blank
             */
            if (column.renderHeadingCell) {
                // 1
                toRender = column.renderHeadingCell(column.headingCellProps);
            }
            else if (column.headingText !== undefined) {
                // 2 (!== undefined as an empty string is falsy, and an empty string might be desirable)
                toRender = column.headingText;
            }
            else if (column.propertyName) {
                // 3
                toRender = morse_react_1.wordifyCamelCase(column.propertyName.toString());
            }
        }
        return (react_1.default.createElement(morse_react_1.TableHeaderCell, __assign({ key: "table-header-cell-" + index }, column.headingCellProps, { sortable: column.sortable, sortDirection: sortDirection, onClick: handleOnClick }), toRender));
    });
    var linkMap = react_1.useMemo(function () {
        var map = new Map();
        if (rowLinkTo) {
            for (var _i = 0, dataset_1 = dataset; _i < dataset_1.length; _i++) {
                var item = dataset_1[_i];
                map.set(item, rowLinkTo(item));
            }
        }
        return map;
    }, [dataset, rowLinkTo]);
    // Build the collection of rows
    var rows = dataset.map(function (item, i) {
        var _a;
        var linkTo = linkMap.get(item);
        // Containing cells
        var cells = columnsWithInjections.map(function (inputColumn, index) {
            var _a, _b;
            var cellProps;
            // Either the value directly from the item, or from a getter if supplied
            var column = typeof inputColumn !== "object" ? { propertyName: inputColumn } : inputColumn;
            if (column.hide) {
                return null;
            }
            cellProps = column.cellProps;
            var toRender;
            // Give the plugins an opportunity to render
            (_a = props.plugins) === null || _a === void 0 ? void 0 : _a.forEach(function (plugin) {
                if (plugin.cellRender) {
                    var pluginWantsToRender = plugin.cellRender(item, column, props.pluginOptions);
                    // Other falsy values may be valid ReactNodes, such as null, hence the explicit check
                    if (pluginWantsToRender !== false) {
                        toRender = pluginWantsToRender;
                    }
                }
            });
            /**
             * Order of precedence
             *  - plugins
             *  - propertyGetter
             *  - propertyName
             *      - formatter
             *      - raw value
             *  - undefined
             */
            if (toRender === undefined) {
                if (column.propertyGetter) {
                    toRender = column.propertyGetter(item);
                }
                else if (column.propertyName) {
                    var value = item[column.propertyName];
                    if (column.formatter) {
                        toRender = column.formatter(value);
                    }
                    else if (value instanceof Date) {
                        toRender = value.toLocaleTimeString();
                    }
                    else {
                        toRender = value;
                    }
                }
                else {
                    toRender = undefined;
                }
            }
            if (toRender === undefined && column.emptyDataRender) {
                if (typeof column.emptyDataRender === "function") {
                    toRender = column.emptyDataRender(item);
                }
                else {
                    toRender = column.emptyDataRender;
                }
            }
            var CellComponent = (_b = column.renderCell) !== null && _b !== void 0 ? _b : morse_react_1.TableCell;
            return (react_1.default.createElement(CellComponent, __assign({ item: item, key: "table-cell-row-" + index + "-column" }, (cellProps !== null && cellProps !== void 0 ? cellProps : {})), linkTo ? (react_1.default.createElement(react_router_dom_1.Link, { style: {
                    display: "block",
                    textDecoration: "inherit",
                    color: "inherit",
                }, to: linkTo }, toRender)) : (toRender)));
        });
        var rowToRender = undefined;
        // If we have a rowRender prop provided delegate this to the parent
        if (rowRender) {
            rowToRender = rowRender(item, cells, i);
        }
        else {
            var handleOnClick = function () {
                var _a;
                if (onRowClick) {
                    onRowClick(item);
                }
                // Tell plugins that this row has been clicked
                (_a = props.plugins) === null || _a === void 0 ? void 0 : _a.forEach(function (plugin) {
                    return plugin.handleRowClick && plugin.handleRowClick(item, props.pluginOptions);
                });
            };
            rowToRender = (react_1.default.createElement(morse_react_1.TableRow, { key: "table-row-" + i, onClick: handleOnClick }, cells));
        }
        // Allow plugins to process what's about to be rendered
        (_a = props.plugins) === null || _a === void 0 ? void 0 : _a.forEach(function (plugin) {
            if (plugin.postRowRender) {
                rowToRender = plugin.postRowRender(rowToRender, item, columns, props.pluginOptions);
            }
        });
        return rowToRender;
    });
    return (react_1.default.createElement(morse_react_1.Table, __assign({}, tableProps),
        react_1.default.createElement(morse_react_1.TableHead, null,
            react_1.default.createElement(morse_react_1.TableRow, null, headings),
            additionalHeaders),
        react_1.default.createElement(morse_react_1.TableBody, null, rows),
        footer && react_1.default.createElement(morse_react_1.TableFoot, null, footer)));
};
exports.DatasetTable = DatasetTable;
//# sourceMappingURL=DatasetTable.js.map